<template>
  <div class="filter">
    <ul>
      <li @click="selectCity" :class="{ selected: true, show: selected.zero }">
        <a href="javascript:;"
          ><span class="text">{{ zeroText }}</span></a
        >
      </li>
      <li
        @click="selectArea"
        :class="{ selected: firstText !== textList[1], show: selected.first }"
      >
        <a href="javascript:;"
          ><span class="text"
            >{{ firstText
            }}<i
              class="iconfont icon-xiajiantou"
              v-show="firstText === textList[1]"
            ></i></span
        ></a>
      </li>
      <li
        @click="selectService"
        :class="{ selected: secondText !== textList[2], show: selected.second }"
      >
        <a href="javascript:;"
          ><span class="text"
            >{{ secondText
            }}<i
              class="iconfont icon-xiajiantou"
              v-show="secondText === textList[2]"
            ></i></span
        ></a>
      </li>
      <!-- <li @click="selectLevel" :class="{'selected':thridText !== textList[3],'show':selected.thrid}"><a href="javascript:;"><span class="text">{{thridText}}<i class="iconfont icon-xiajiantou" v-show="thridText === textList[3]"></i></span></a></li> -->
    </ul>
    <actionSheet :viewName="viewName" :params="params"></actionSheet>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import actionSheet from '../actionSheet/upAction'

export default {
  props: {
    citycode: {
      type: [String, Number],
      default: '320100'
    },
    cityname: {
      type: String,
      default: '南京市'
    }
  },
  data() {
    return {
      params: {},
      selected: { zero: false, first: false, second: false, thrid: false },
      textList: ['', '服务区域', '服务项目', '服务星级'],
      zeroText: '',
      firstText: '服务区域',
      secondText: '服务项目',
      thridText: '服务星级',
      selectAllText: '全部'
    }
  },
  computed: {
    ...mapState([
      'viewName',
      'serverArea',
      'serviceTypeList',
      'filterCity',
      'filterArea',
      'filterLevel',
      'filterTime',
      'filterService',
      'starLevelsList',
      'areaList',
      'isActionSheetShow'
    ])
  },
  created() {
    this.zeroText = decodeURI(this.cityname || '南京')
    this.textList[0] = this.zeroText || '南京'
  },
  watch: {
    isActionSheetShow(val) {
      if (!val) {
        this.selected = { first: false, second: false, thrid: false }
      }
    },
    serverArea(val, oldVal) {
      this.selected.first = false
      if (val && val.length > 0) {
        if (val.length === this.areaList.length) {
          this.firstText = this.selectAllText
        } else {
          const texts = val.map(area => area.NAME)
          this.firstText = texts.join('、')
        }
      } else {
        this.firstText = this.textList[1]
      }
      this.$emit('doSearch')
    },
    filterLevel(val) {
      this.selected.thrid = false
      if (val && val.length > 0) {
        if (val.length === this.starLevelsList.length) {
          this.thridText = this.selectAllText
        } else {
          const texts = val.map(star => star.starLevelName)
          this.thridText = texts.join('、')
        }
      } else {
        this.thridText = this.textList[3]
      }
      this.$emit('doSearch')
    },
    // filterTime(val) {
    //     this.selected.thrid = false
    //     if (val) {
    //         this.thridText = val
    //     } else {
    //         this.thridText = this.textList[2]
    //     }
    //     this.$emit('doSearch')
    // },
    filterService(val) {
      this.selected.second = false
      if (val && val.length > 0) {
        if (val.length === this.serviceTypeList.length) {
          this.secondText = this.selectAllText
        } else {
          const texts = val.map(s => s.categoryName)
          this.secondText = texts.join('、')
        }
      } else {
        this.secondText = this.textList[2]
      }
      this.$emit('doSearch')
    }
  },
  methods: {
    ...mapMutations([
      'hideActionSheet',
      'showActionSheet',
      'changeView',
      'setActionHeader'
    ]),
    selectCity() {
      location.replace(
        `//life.cekid.com/h5/city-choose?referer=${encodeURIComponent(
          location.href
        )}`
      )
    },
    selectArea() {
      if (this.selected.first) {
        this.hideActionSheet(false)
        this.selected.first = false
      } else {
        this.selected = { first: false, second: false, thrid: false }
        this.selected.first = true
        this.params = {
          cityId: this.citycode,
          needRestBt: true,
          needSelectAll: true,
          supportMuti: true
        }
        this.changeView('enteringAreaSelect')
        this.setActionHeader({
          title: '',
          show: false
        })
        this.showActionSheet()
      }
    },
    selectService() {
      if (this.selected.second) {
        this.hideActionSheet(false)
        this.selected.second = false
      } else {
        this.hideActionSheet(false)
        this.selected = { first: false, second: false, thrid: false }
        this.selected.second = true
        this.params = { needRestBt: true, supportMuti: true }
        this.changeView('serviceSheet')
        this.setActionHeader({
          title: '',
          show: false
        })
        this.showActionSheet()
      }
    },
    selectLevel() {
      if (this.selected.thrid) {
        this.hideActionSheet(false)
        this.selected.thrid = false
      } else {
        this.hideActionSheet(false)
        this.selected = { first: false, second: false, thrid: false }
        this.selected.thrid = true
        this.params = { cityId: this.citycode, needRestBt: true }
        this.changeView('starSheet')
        this.setActionHeader({
          title: '',
          show: false
        })
        this.showActionSheet()
      }
    },
    selectTime() {
      if (this.selected.thrid) {
        this.hideActionSheet(false)
        this.selected.thrid = false
      } else {
        this.hideActionSheet(false)
        this.selected = { first: false, second: false, thrid: false }
        this.selected.thrid = true
        // this.params = { cityId: this.citycode, needRestBt: true }
        this.changeView('dateSheet')
        this.setActionHeader({
          title: '',
          show: false
        })
        this.showActionSheet()
      }
    }
  },
  components: {
    actionSheet
  }
}
</script>
<style lang="scss">
@import '../../assets/css/mixin';

.filter {
  .ui-address-choose {
    bottom: none !important;
    width: 100%;
  }
  .ui-address-choose {
    bottom: rem(100px) !important;
    .ui-address-choose-select {
      margin-bottom: 0 !important;
      .ui-address-choose-select-item {
        margin-left: rem(30px);
        width: rem(330px);
        display: inline-block;

        &::after {
          content: none !important;
        }
      }
    }
  }
  .ui-choose {
    bottom: 1rem !important;
    .ui-choose-select {
      margin-bottom: 0 !important;
    }
  }

  .ui-button {
    font-size: rem(36px);
  }
}
</style>
<style lang="scss" scoped>
@import '../../assets/css/mixin';
.filter {
  width: 100%;
  height: rem(90px);
  @include border(bottom);
  background-color: #fff;
  position: relative;
  z-index: 999;

  ul {
    position: relative;
    padding: rem(17px) 0 rem(17px) rem(25px);
    height: rem(90px);
    box-sizing: border-box;
    text-align: center;
    z-index: 999;
    display: flex;
    // align-items: center;

    li {
      padding-right: rem(30px);
      position: relative;
      flex: 1;
      z-index: 999;
      box-sizing: border-box;
      font-size: rem(24px);

      a {
        display: block;
        position: relative;
        padding: 0 rem(10px);
        height: rem(56px);
        line-height: rem(56px);
        color: #121212;
        background-color: #f4f4f4;
        border-radius: 2px;
        @include border;
      }

      span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        box-sizing: border-box;
        position: relative;
        display: inline-block;
        max-width: 100%;
        // padding-right: rem(26px);
      }

      .iconfont {
        padding-left: rem(8px);
        // padding-right:rem(8px);
        color: #121212;
        font-size: rem(20px);
      }
    }

    // li:nth-child(2) span{
    //     display: block;
    // }
    .show {
      a {
        color: #121212 !important;
        height: rem(74px);
        background-color: #fff;
      }
      a::after {
        content: '';
        position: absolute;
        left: 1px;
        right: 1px;
        bottom: 0;
        height: 4px;
        background: #fff;
        z-index: 2;
      }

      a::before {
        border-color: #ebebeb !important;
        border-bottom-color: #fff !important;
      }
      .iconfont {
        // display: inline-block;
        // transform: rotate(180deg);
        // transition: transform .2s;
        // padding-right:rem(8px);
        // padding-left:0;
      }
    }
    .selected {
      a {
        color: #ff397e;
        background-color: #fff;
      }

      a::before {
        border-color: #ff397e;
      }
      .iconfont {
        color: #ff397e;
      }
    }
  }
}
</style>
